export default "__VITE_ASSET__DerGgNYO__"